import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { UrlSettingsCore } from '../../configuration/url-settings-core';
import { AttivitaCompletare } from '../../models/attivita-completare';
import { PrendiAttivitaCompletareResponse } from '../../models/prendi-attivita-completare-response';
import { RefreshHeader } from '../../models/refresh-header';
import { OperationsService } from '../../services/operations.service';
import { ViewManagerService } from '../../services/view-manager-service';
import { AppData } from 'src/app/data-store';

@Component({
  selector: '[attivita-completare]',
  templateUrl: 'attivita-completare.component.html',
  styleUrls: ['attivita-completare.component.css'],
})

export class AttivitaCompletareComponent implements OnInit {

  numToView: number = 4;
  viewAllAttivitaCompletare: string = UrlSettingsCore.URL_ATTIVITA_COMPLETARE;
  attivitaCompletareList: AttivitaCompletare[] = [];
  attivitaTotali: number = 0;
  polling: boolean = true;
  subscriptionAttivitaCompletare: Subscription;
  @Output() onClick = new EventEmitter();
  constructor(private viewManager: ViewManagerService,
              private operationService: OperationsService) {}

  ngOnInit() {
    this.subscriptionAttivitaCompletare = this.viewManager.refreshAttivitaCompletare.subscribe(param => this.refreshAttivitaCompletare(param));
    if(!AppData.getInstance().attivitaCompletare) {
      this.prendiAttivitaCompletare();
    } else {
      this.listaPresa(AppData.getInstance().attivitaCompletare);
    }
  }

  private refreshAttivitaCompletare(response?: RefreshHeader) {
    if(response && response.param){
      this.listaPresa(response.param);
    }else{
      this.prendiAttivitaCompletare();
    }
  }

  private prendiAttivitaCompletare() {
    if (this.polling) {
      this.operationService.prendiAttivitaCompletarePaginate({fromResult: 0}).
        subscribe(response => {
          AppData.getInstance().attivitaCompletare = response;
          this.listaPresa(response)
        });
  }
}

  private listaPresa(response: PrendiAttivitaCompletareResponse) {
    AppData.getInstance().attivitaCompletare = response;
    if(response.attivita != undefined){
      for (let attivita of response.attivita) {
        let dateObj = new Date();
        dateObj.setHours(0, 0, 0, 0);
        let date = dateObj.getTime();
        if (date > attivita.dataNotifica) {
          let giorniRitardo = Math.ceil((date - attivita.dataNotifica) / (1000 * 60 * 60 * 24));
          if (giorniRitardo > 0) {
            attivita.giorniRitardo = giorniRitardo;
          }
        }
      }
    this.attivitaCompletareList = response.attivita;
    this.attivitaTotali = response.numeroAttivitaTotali;
    }
  }

  ngOnDestroy() {
    this.polling = false;
  }

  getAriaLabel() {
    if(this.attivitaTotali > 0) {
      return "Sono presenti " + this.attivitaTotali + " " + "attività da completare";
    } else {
      return "Non ci sono attività da completare";
    }
  }
}
